import { PropertyNoteDTO } from "../DTO/propertyNoteDTO";
import { isGuid } from "../theme/utils/app-validators";
import { VisibleTo } from "./visibleTo";

export class PropertyNote{
    public id?:number;
    public propertyId!:number;
    public note!:string;
    public userId?:string;
    public userName?:string;
    public userFirstName?:string;
    public userLastName?:string;
    public added?:Date;
    public edited?:Date;
    public context?:string;
    public contextId?:string;
    /** who may see the note besides super admins (bitmask): 0=super admin only, 1=client users, 2=attorneys (reserved). undefined = not specified */
    public visibleTo?:number;

    /** visibleTo bit: released to client users */
    public static readonly VisibleToClient = VisibleTo.Client;

    /** note contexts that are never released (lead notes are about buyers); the server never returns them to client users either */
    public static readonly InternalOnlyContexts = ['leads'];

    get isInternalOnly(){
        return !!this.context && PropertyNote.InternalOnlyContexts.includes(this.context);
    }

    get isVisibleToClient(){
        return VisibleTo.includes(this.visibleTo, VisibleTo.Client);
    }

    public static mapToDTO(param:PropertyNote) : PropertyNoteDTO{
        
        let dto = new PropertyNoteDTO();
        try
        {
            dto.id = param.id;
            dto.propertyId = param.propertyId;
            dto.note = param.note;
            dto.userId = param.userId;
            dto.userName = param.userName;
            dto.userFirstName = param.userFirstName;
            dto. userLastName = param.userLastName;
            if(param.added) dto.added = param.added.toISOString();
            if(param.edited) dto.edited = param.edited.toISOString();
            dto.context = param.context;
            dto.contextId = param.contextId;
            dto.visibleTo = param.visibleTo;
        }
        catch(e)
        {
            console.log(e);
        }
        return dto;
    }
    public static mapFromDTO(param:PropertyNoteDTO) : PropertyNote
    {
        
        let obj = new PropertyNote();
        try
        {
            obj.id = param.id;
            obj.propertyId = param.propertyId;
            obj.note = param.note;
            obj.userId = param.userId;
            obj.userName = param.userName;
            obj.userFirstName = param.userFirstName;
            obj. userLastName = param.userLastName;
            if(param.added) obj.added = new Date(param.added);
            if(param.edited) obj.edited = new Date(param.edited);
            obj.context = param.context;
            obj.contextId = param.contextId;
            obj.visibleTo = param.visibleTo ?? undefined;
        }
        catch(e)
        {
            console.log(e);
        }
        return obj;
    }

    get userFullName(){
        return this.userFirstName + ' ' + this.userLastName;
    }

    get displayContext(){
        let context = this.context?.toString();
        if (!context) {
            return '';
        }
        const contextId = (this.contextId && !isGuid(this.contextId))? this.contextId : '';
        if(contextId.length) context +=' (' + contextId + ')';
        return context.replace(/_/g, ' ').replace(/\b\w/g, char => char.toUpperCase());
    }
}